import { Asterisk } from "lucide-react";

const items = [
  "Sem dietas restritivas",
  "Recomeço metabólico 40+",
  "Hábitos realistas de 21 dias",
  "Resultados sustentáveis",
  "Energia & disposição diária",
  "Método, não motivação",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {items.map((item) => (
      <span key={item} className="flex items-center">
        <span className="whitespace-nowrap px-8 font-display text-xl font-medium italic tracking-wide text-primary-foreground/85 sm:text-2xl">
          {item}
        </span>
        <Asterisk className="h-5 w-5 shrink-0 text-accent" />
      </span>
    ))}
  </div>
);

const Marquee = () => (
  <div
    data-testid="marquee-container"
    className="overflow-hidden border-y border-primary/20 bg-primary py-5"
  >
    <div className="animate-marquee flex w-max">
      <Row />
      <Row />
    </div>
  </div>
);

export default Marquee;
